module.exports = __webpack_public_path__ + "static/media/body.5df85db8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/body.png
// module id = 56
// module chunks = 0